import { axios } from '@/services/axios';

export const updateRegion = (regionData) => {
    return axios.put('/region/', regionData);
};
